import { ActionType } from '../../types';

export const TrendChannelActions = {
    trendChannelsSelected: (channels: Array<{ id: string; channelName: string; deviceId: string }>) =>
        ({
            type: 'TrendChannels/Selected',
            payload: { channels },
        } as const),

    trendChannelsForGraph: (channels: number[]) =>
        ({
            type: 'TrendChannels/Graph',
            payload: { channels },
        } as const),
};

export type TrendChannelActions = ActionType<typeof TrendChannelActions>;
